import {
  Comparator,
  ComparatorProps,
  GraphCBHealthApi,
  GraphComparisonApiService,
  IPartnerContext,
  PartnerProvider,
  transformers,
  validators,
} from '@kizi/comparator-core';
import { ThemeProvider } from '@kizi/core-components';
import React, { useEffect } from 'react';
import { layout, steps } from './config/machine.config';
import themeOsSample from './themes/os/themeOSSample';
import {
  getApiCredentials,
  handlePartnerContext,
} from './utils/helperFunctions';
import { getSetupEvent } from './utils/peregrine';

export type StartWidgetProps = Partial<Omit<ComparatorProps, 'steps'>> & {
  steps?:
    | ComparatorProps['steps']
    | ((steps?: ComparatorProps['steps']) => ComparatorProps['steps']);
  partnerContext?: IPartnerContext;
};

function StartWidget(props: StartWidgetProps) {
  const overriddenSteps =
    typeof props.steps === 'function' ? props.steps(steps) : steps;

  const { isPartner, partnerContext, theme } = handlePartnerContext(
    props,
    themeOsSample,
  );

  useEffect(() => {
    if (!isPartner) {
      const head = globalThis.document.head;
      const body = globalThis.document.body;
      console.warn({ head, body });

      const script = globalThis.document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = `
          (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
            var f = d.getElementsByTagName(s)[0],
              j = d.createElement(s),
              dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
          })(window, document, 'script', 'dataLayer', 'GTM-WCVXXG8K');
        `;

      const noscript = globalThis.document.createElement('noscript');
      noscript.innerHTML = `
      <!-- Google Tag Manager (noscript) -->
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-WCVXXG8K"
          height="0"
          width="0"
          style="display: none; visibility: hidden"
        ></iframe>`;

      //head.insertBefore(script, head.firstChild);
      //body.insertBefore(noscript, body.firstChild);
    }
  }, []);
  return (
    <ThemeProvider theme={theme}>
      <PartnerProvider value={partnerContext}>
        <Comparator
          validators={validators}
          transformers={transformers}
          layout={[layout[0]]}
          name="os-health"
          loadFn={() => import('./components/index')}
          {...props}
          steps={overriddenSteps}
          getPeregrineSetupEvent={getSetupEvent}
          isPartner={isPartner}
          api={
            new GraphComparisonApiService<GraphCBHealthApi>(
              {
                baseUrl: process.env.KIZI_PUBLIC_GRAPH_API_BASE_URL ?? '',
                tokenUrl: process.env.KIZI_PUBLIC_API_ACCESS_TOKEN_URL ?? '',
                credentials: getApiCredentials(isPartner, partnerContext),
              },
              GraphCBHealthApi,
            )
          }
        />
      </PartnerProvider>
    </ThemeProvider>
  );
}

export default StartWidget;
